import { createFileRoute, Outlet } from '@tanstack/react-router'
export const Route = createFileRoute('/svatba/$token')({ component: Outlet })
